module.exports = __webpack_public_path__ + "images/category_lp/hobby/store_images/4_033cd3dc2d254ac55a4390704244cc43.png";